
<template>
  <div
    v-if="shouldShow"
    :class="{ mastery: mastery }"
    class="google-component-container"
    @click="authenticate()"
  >
    <icon
      v-if="mastery"
      :name="'google'"
      class="icon"
    />
  </div>
</template>

<script>
import Authentication from '@/mixins/authentication';
import Icon from '@components/singletons/icon';

export default {
  components: { Icon },
  mixins: [Authentication],
  props: {
    createAccount: {
      type: Boolean,
      default: false,
    },
    mastery: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    shouldShow() {
      return this.$store.getters['app/logInWithGoogle'];
    },
  },
  methods: {
    async authenticate() {
      const gAuthCode = await this.$gAuth.getAuthCode();
      const trackingParams = this.collectTrackingParams();
      this.$notify({
        group: 'notifications',
        text: 'Authenticating',
        type: 'success',
      });

      this.$store.dispatch('session/signIn', [{ gAuthCode, ...trackingParams }]).then(response => {
        this.$notify({
          group: 'notifications',
          text: 'You are now logged in',
          type: 'success',
        });
        this.redirectAfterSignIn();
      }).catch(e => {
        console.log('error');
        console.log(e);
        this.errorNotification();
      });
    },
    errorNotification() {
      this.$notify({
        group: 'notifications',
        text: 'Google Authentication Failed.',
        type: 'error',
      });
    },
  },
};
</script>
<style lang='scss' scoped>
  .google-component-container {
    box-sizing: border-box;
    background-color: rgba(238, 238, 238, 1);
    cursor: pointer;

    &.mastery {
      border-radius: var(--radius-full);
      display: grid;
      place-content: center;
      height: 44px;
      width: 44px;
    }

    .icon {
      width: 24px;
      height: 24px;
    }
  }
</style>
